import { render, staticRenderFns } from "./StudentListTable.vue?vue&type=template&id=2ce80350"
import script from "./StudentListTable.vue?vue&type=script&lang=js"
export * from "./StudentListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports